module.exports = __webpack_public_path__ + "static/media/memberIcon.973578a7.svg";